"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDropDown = void 0;
const react_1 = __importStar(require("react"));
const CheckboxForm_1 = __importDefault(require("./CheckboxForm"));
const Input_1 = __importDefault(require("./Input"));
const createDropDown = (datasetWrapper, selectedDataset, data, start = 0) => {
    const array = [];
    for (let key of Object.keys(data)) {
        if (data[key] instanceof Object && data[key] instanceof Array) {
            array.push(react_1.default.createElement(CheckboxForm_1.default, { key: key, title: key, data: data[key], selectedDataset: selectedDataset, datasetWrapper: datasetWrapper }));
        }
        else {
            array.push(react_1.default.createElement(LiElement, { key: key, datasetWrapper: datasetWrapper, selectedDataset: selectedDataset, data: { label: key, value: data[key] }, start: start }));
        }
    }
    array.push(array.splice(array.findIndex((item) => {
        if (item.type === "li")
            return item;
    }), 1)[0]);
    return array;
};
exports.createDropDown = createDropDown;
const LiElement = ({ datasetWrapper, selectedDataset, data, start, }) => {
    const liElement = (0, react_1.useRef)(null);
    return (react_1.default.createElement("li", { ref: liElement, className: start > 0
            ? "nameList-sub"
            : "flex items-center bg-agrey-444 py-2 pl-6 text-white", "data-not": start > 0 ? undefined : "true" },
        react_1.default.createElement(Input_1.default, { selectedDataset: selectedDataset, data: data, datasetWrapper: datasetWrapper, liRef: liElement })));
};
